import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import tailwindConfig from '../../tailwind.config';

const fontSizeKeys = Object.keys(tailwindConfig.theme?.extend?.fontSize ?? {});

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': fontSizeKeys.map((key) => `text-${key}`),
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
